import React, { useState, useEffect, ChangeEvent } from 'react';
import * as S from './styles';
import { FormTextAreaProps } from './types';

const FormTextArea: React.FC<FormTextAreaProps> = ({
  label,
  name,
  id,
  value,
  onChange,
  required = false,
  disabled = false,
  rows = 4,
  placeholder,
  maxLength,
  labelPosition = 'left',
  fullWidth = false,
  width,
  error,
  className,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [charCount, setCharCount] = useState(String(value).length);
  const [isNearMax, setIsNearMax] = useState(false);

  useEffect(() => {
    setCharCount(String(value).length);

    if (maxLength) {
      // Considera "perto do limite" quando está com 90% ou mais da capacidade
      setIsNearMax(String(value).length >= maxLength * 0.9);
    }
  }, [value, maxLength]);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <S.FormTextAreaContainer
      labelPosition={labelPosition}
      fullWidth={fullWidth}
      width={width}
      className={className}
    >
      <S.Label
        htmlFor={id || name}
        labelPosition={labelPosition}
        required={required}
        hasError={Boolean(error)}
      >
        {label}
      </S.Label>

      <div style={{ width: '100%' }}>
        <S.TextArea
          id={id || name}
          name={name}
          value={value}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
            onChange(e);
            setCharCount(e.target.value.length);
          }}
          rows={rows}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          hasError={Boolean(error)}
          isFocused={isFocused}
          onFocus={handleFocus}
          onBlur={handleBlur}
          maxLength={maxLength}
          {...props}
        />

        {maxLength && (
          <S.CharacterCounter isNearMax={isNearMax}>
            {charCount}/{maxLength}
          </S.CharacterCounter>
        )}

        {error && <S.ErrorMessage>{error}</S.ErrorMessage>}
      </div>
    </S.FormTextAreaContainer>
  );
};

export default FormTextArea;